<template>
    <div class="wisdom-home">
        <!-- 头部导航 -->
        <headerBlack-view></headerBlack-view>
        <!-- 主体内容 -->
        <div class="wisdom-home-container">
              <div class="wisdom-banner">
                <div class="wisdom-banner-wrapper main">
                    <h2 class="title">首师智研</h2>
                    <p class="introduce">双优项目是集合首师大的优质资源项目形成的以“社会服务”为核心，
                    搭载“首都教育远程互助工程”向全国地区推送首都师范大学的“社会服务”类研修项目。
                    发挥首师大在教育教学研究层面的优势集中力量协助帮扶地区就教师能力体系提升提供全方面的解决方案。</p>
                </div>
              </div>
              <div class="sub-navigate">
                  <ul class="sub-nav-ul main flex-layout">
                        <li v-for="(item,index) in navigate" 
                            :key="index" 
                            :class="{'active': active == index + 1}"
                            @click="handleClick(item,index)"
                            class="csp">
                            {{item.name}}
                        </li>
                  </ul>
              </div>
              <router-view :columnId="currentColumnId"></router-view>
              
        </div>
        <footer-view></footer-view>
  </div>
</template>

<script>
export default {
    data() {
        return {
            navigate:[ //导航list
                // {   
                //     name:'学科培训',
                //     path:'subject'
                // },
                // {   
                //     name:'专项培训',
                //     path:'special'
                // },
                // {
                //     name:'专家团队',
                //     path:'expert'
                // },
                // {
                //     name:'项目案例',
                //     path:'project'
                // }
            ],
            active:1, //当前被选中的导航
            currentColumnId:0,
        }
    },
    watch:{},
    methods: {
        handleClick(item,index) {
            this.active = index + 1;
            sessionStorage.setItem('wsActive',index + 1);
            this.currentColumnId = item.id
            this.$nextTick(function(){
                this.$router.push({
                   path:item.path
                });
            })
        },
        async getColumnLsit() {
            let id = 90  //90是首师智研
            let resData = await Api.Wisdom.getColumnLsit(id)
            // console.log(resData)       
            this.navigate = resData.data
            this.currentColumnId = this.navigate[0].id
            // console.log(this.currentColumnId);
        },
        init() {
            if(sessionStorage.getItem('wsActive')) {
            this.active = sessionStorage.getItem('wsActive')
            } else {
                let xPath = window.location.href.split('/')[window.location.href.split('/').length - 1];
                this.navigate.map((item,index)=>{
                    if(item.path === xPath) {
                        this.active = index + 1
                        sessionStorage.setItem('wsActive',this.active);
                    }
                })
            }
        }
    },
    created(){
        sessionStorage.setItem('projectID',90);
    },
    mounted() {
        this.getColumnLsit();
        this.init();
    },
    destroyed() {
        sessionStorage.removeItem('wsActive');
    }
}
</script>

<style lang="less" scoped>
    @import "./less/wisdom_home.less";
</style>